import { Injectable } from '@angular/core';
import * as PrismicDOM from 'prismic-dom';
import { Document } from 'prismic-javascript/types/documents';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrismicService } from '../prismic.service';
import { GamificationActivityType } from '../types/gamification-activity-type';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';
import { Language } from '../types/language';

@Injectable({
  providedIn: 'root',
})
export class BadgeDescriptionService {
  defaultLanguage = Language.ENGLISH;

  constructor(private prismic: PrismicService) {}

  private getHTMLFromPrismicDoc(doc: Document): string {
    if (!doc) {
      return '';
    }

    return PrismicDOM.RichText.asHtml(doc.data.facts || doc.data.message);
  }

  fetchDescription(
    badge: GamificationBadgeDto,
    translationLanguage: Language
  ): Observable<string[]> {
    const isWeeklyBadge =
      badge.activityType === GamificationActivityType.COMPLETE_WEEKLY_CHALLENGE;

    const query = isWeeklyBadge
      ? this.prismic.Predicates.at('my.badge-fact.uid', badge.uuid)
      : this.prismic.Predicates.at(
          'my.activity-type-description.type',
          badge.activityType
        );

    const descriptionLanguage = isWeeklyBadge
      ? `${this.defaultLanguage}-oe`
      : `${translationLanguage}-oe`;

    return this.prismic.query(query, '*').pipe(
      map((results) => {
        if (!results) {
          return;
        }

        const result = results.find(
          (result) => result.lang === descriptionLanguage
        );

        const description = this.getHTMLFromPrismicDoc(result);

        if (!isWeeklyBadge) {
          return [description];
        }

        const resultTranslation = results.find(
          (result) => result.lang === `${translationLanguage}-oe`
        );

        const descriptionTranslation = this.getHTMLFromPrismicDoc(
          resultTranslation
        );
        return [description, descriptionTranslation];
      })
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/badge-description/badge-description.service.ts